export const APP_NAME = 'skill_page_perseus';

export const ROLLOUTS = {
    MEERKATS_PRO_SKILLS_CATALOG: 'meerkats_pro_skills_catalog',
} as const;
